import React from 'react';
import PropTypes from 'prop-types';
import { Column } from 'nucleus-core/layout/flexbox';
import Permissions from '../../../permissions/EditorPermissions';

/**
 * Default renderer for a SECTION_COLUMN type layout item.
 */
export default class SectionColumn extends React.Component {
  static displayName = 'SectionColumn';
  static propTypes = {
    layoutItem: PropTypes.object.isRequired,
    children: PropTypes.node,
    emptyContentComponent: PropTypes.func,
    canvasPermissions: PropTypes.object
  };
  render() {
    const { layoutItem, children, canvasPermissions } = this.props;
    const showEmptyContent =
      this.props.emptyContentComponent &&
      !React.Children.count(children) &&
      (!canvasPermissions || canvasPermissions.content !== Permissions.NONE);
    return (
      <Column size={layoutItem.layout.colspan}>
        {showEmptyContent ? (
          <this.props.emptyContentComponent layoutItem={layoutItem} />
        ) : (
          children
        )}
      </Column>
    );
  }
}
